import { render, staticRenderFns } from "./contactPage.vue?vue&type=template&id=53b48dbd&scoped=true"
import script from "./contactPage.vue?vue&type=script&lang=js"
export * from "./contactPage.vue?vue&type=script&lang=js"
import style0 from "./contactPage.vue?vue&type=style&index=0&id=53b48dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b48dbd",
  null
  
)

export default component.exports